import { Component, HostBinding, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../services/shared.service';
import { AuthService } from '../services/auth.service';
import { HomeService } from '../services/home.service';
import { Constants } from '../constants';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  standalone: false
})
export class AuthComponent implements OnInit {

  @HostBinding('class') class = 'fullWith';

  public visible: boolean = true;
  public changetype: boolean = true;
  public tokenNotExist: boolean = false;
  private redirectTimeoutId?: number;

  constructor(private authService: AuthService, private sharedService: SharedService, private homeService: HomeService) {
  }

  public ngOnInit(): void {
    this.redirectTimeoutId = window.setTimeout(() => {
      if (this.sharedService.getTokenConfig()) {
        this.redirectAfterAuth();
      }
    }, 30000);
  }

  /**
   * Centralized navigation logic after authentication (timeout or submit)
   */
  private redirectAfterAuth(): void {
    this.homeService.loadNews();
    this.homeService.allNews.subscribe(news => {
      this.sharedService.navigateAfterAuth(news);
    });
  }

  public viewToken() {
    this.visible = !this.visible;
    this.changetype = !this.changetype;
  }

  public submitToken(token: string): void {
    // Annuler le timeout de redirection automatique
    if (this.redirectTimeoutId) {
      window.clearTimeout(this.redirectTimeoutId);
      this.redirectTimeoutId = undefined;
    }
    this.authService.getTokenConfig(token).subscribe({
      next: result => {
        if (result) {
          this.tokenNotExist = false;
          this.sharedService.setTokenConfig(result);
          this.redirectAfterAuth();
        } else {
          this.tokenNotExist = true;
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.tokenNotExist = true;
          return;
        }
        this.sharedService.navigate([Constants.RedirectUrl.Error]);
      }
    });
  }
}
